import React from "react";
import Checkbox from './index'
import UnconfiguredComponent from '../common3/UnconfiguredComponent'

import isEmpty from 'lodash/isEmpty'

const CheckboxEdit = (props) => {
  const { extra = {},builder,effects } = props;
  const { options = null,optionsType } = extra;

  if( builder && ( (optionsType === 'static' && isEmpty(options))) ) {
    return <UnconfiguredComponent hint='Add options to component'/>
  }

  if( optionsType === 'effects' || optionsType === 'register' ) {
    return <Checkbox {...props} extra={{...props.extra, options:'test'}} effects={ {...props.effect, ...{ [props.id] : [{label:'Dynamic Content #1', value:'dynamic1'},{label:'Dynamic Content #2', value:'dynamic1'},{label:'Dynamic Content #3', value:'dynamic1'}]}}}/>

  }

  return <Checkbox {...props}/>
};

export default CheckboxEdit
